import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UiService {
  public sorting$: BehaviorSubject<string>;
  public displayMode$: BehaviorSubject<string>;
  public currentPagingPage$: BehaviorSubject<number>;

  private filterVisibilitySubject = new BehaviorSubject<boolean>(true);
  public filterVisibility$ = this.filterVisibilitySubject.asObservable();

  toggleFilters(): void {
    this.filterVisibilitySubject.next(!this.filterVisibilitySubject.value);
  }

  setFiltersVisibility(visible: boolean): void {
    this.filterVisibilitySubject.next(visible);
  }

  constructor() {
    this.sorting$ = new BehaviorSubject('date:reverse');
    this.displayMode$ = new BehaviorSubject('grid');
    this.currentPagingPage$ = new BehaviorSubject(1);
  }
}
